export default "/static/images/build_roof_7.png?fb9d092ce9dac4c36b57c8b3b9392beb";